import { right } from "fp-ts/lib/Either";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";
import callAPI from "../../../fetchCallImplementation";

/**
 * Calls the /newaievaluation endpoint and returns job_id
 * Now returns 202 with {"job_id": job_id, "status": "QUEUED"}
 */
const GetNewAIEvaluationApiImpl = async (recording: string): Promise<any> => {
    const baseUrl = di.get<Constants>(ConstantsName).AI;
    const response = await callAPI(baseUrl + `/newaievaluation/parsedFiles/${recording}`, 'GET', {});

    // Handle 202 Accepted response with job_id
    if (response.status === 202) {
        const data = await response.json();
        if (data.job_id && data.status === "QUEUED") {
            return right({ job_id: data.job_id, status: data.status });
        }
        throw new Error("Invalid response format: missing job_id or status");
    }

    // Handle other error responses
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Failed to create AI evaluation");
    }

    // Legacy stream handling (if response is not 202)
    const reader = response.body?.getReader();

    if (!reader) {
        throw new Error("Readable stream not supported or body is empty.");
    }
    
    let result = '';
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        result += decoder.decode(value, { stream: true });
    }

    // Decoding the last chunk
    result += decoder.decode();
    
    return right(result);
}

export default GetNewAIEvaluationApiImpl;